import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { makeStyles } from '@material-ui/core/styles';
import Column from './Column';
import InputCard from './Input';
import store from '../utils/store';
import storeApi from '../utils/storeApi';

const useStyle = makeStyles({
  root: {
    minHeight: '100vh',
    width: '100%',
    overflowY: 'auto',
    display: 'flex',
  },
});

function Wrapper() {
  const classes = useStyle();
  const [data, setData] = useState(store);

  const addMoreCard = (content, listId) => {
    const newCardId = uuidv4();
    const newCard = {
      id: newCardId,
      content,
    };
    const list = data.lists[listId];
    list.cards = [...list.cards, newCard];
    const newState = {
      ...data,
      lists: {
        ...data.lists,
        [listId]: list,
      },
    };

    setData(newState);
  };

  const addMoreList = (title) => {
    const newListId = uuidv4();
    const newList = {
      id: newListId,
      title,
      cards: [],
    };

    const newState = {
      listIds: [...data.listIds, newListId],
      lists: {
        ...data.lists,
        [newListId]: newList,
      },
    };
    setData(newState);
  };

  // Listen for event when the user drop the  card
  const onDragEnd = (result) => {
    const { destination, source, draggableId, type } = result;
    if (!destination) {
      return;
    }

    if (type === 'list') {
      const newListIds = data.listIds;
      newListIds.splice(source.index, 1);
      newListIds.splice(destination.index, 0, draggableId);
      const newState = {
        ...data,
        listIds: newListIds,
      };
      setData(newState);
      return;
    }

    const sourceList = data.lists[source.droppableId];
    const destinationList = data.lists[destination.droppableId];
    const draggingCard = sourceList.cards.filter(
      (card) => card.id === draggableId
    )[0];
    let newState;
    if (source.droppableId === destination.droppableId) {
      sourceList.cards.splice(source.index, 1);
      sourceList.cards.splice(destination.index, 0, draggingCard);
      newState = {
        ...data,
        lists: {
          ...data.lists,
          [sourceList.id]: sourceList,
        },
      };
      setData(newState);
    } else {
      sourceList.cards.splice(source.index, 1);
      destinationList.cards.splice(destination.index, 0, draggingCard);

      newState = {
        ...data,
        lists: {
          ...data.lists,
          [sourceList.id]: sourceList,
          [destination.id]: destinationList,
        },
      };
    }
    setData(newState);
  };
  const handleUpdateTitle = (title, listId) => {
    const list = data.lists[listId];
    list.title = title;
    const newState = {
      ...data,
      lists: {
        ...data.lists,
        [listId]: list,
      },
    };

    setData(newState);
  };
  return (
    <storeApi.Provider value={{ addMoreCard, addMoreList }}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="app" type="list" direction="horizontal">
          {(provided) => (
            <div
              className={classes.root}
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {data.listIds.map((listId, index) => {
                const list = data.lists[listId];
                return (
                  <Column
                    index={index}
                    list={list}
                    key={listId}
                    handleUpdateTitle={handleUpdateTitle}
                  />
                );
              })}
              <InputCard type="list" />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </storeApi.Provider>
  );
}

export default Wrapper;
